import deductibleTrackerResource from "@/shared/resource/deductibleTracker";
import { authorizedAxios } from "./authorizedAxios";

export function getIframeUrl () {
  return authorizedAxios.get(deductibleTrackerResource.getGenerateMymedicalshopperUrl());
}

export function getHealthPlanIsLinked () {
  return authorizedAxios.get(deductibleTrackerResource.getHealthPlanIsLinked());
}

export function getHealthPlans () {
  return authorizedAxios.get(deductibleTrackerResource.getHealthPlans());
}